// Problem: https://stackoverflow.com/questions/42615445/vuejs-2-0-emit-event-from-grand-child-to-his-grand-parent-component
// Solution: 
// - https://www.digitalocean.com/community/tutorials/vuejs-global-event-bus
// - https://medium.com/vuejobs/create-a-global-event-bus-in-vue-js-838a5d9ab03a

import Vue from 'vue';
export const EventBus = new Vue();
